import React from "react";
import Header from "./components/Header";
import history from "./history";
import { Router, Route, Switch } from "react-router-dom";
import Landing from "./components/Landing";
import PasssGuard from "./components/PasssGuard";
import GameGuard from "./components/GameGuard";
import Carpark from "./components/Carpark";
import SpendGuard from "./components/SpendGuard";
import TransportGuard from "./components/TransportGuard";
import FootageDoctor from "./components/FootageDoctor";
import FootageDoctorPrivacy from "./components/FootageDoctorPrivacy";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div>
      <Router history={history}>
        <div>
          <Header />
          <ScrollToTop>
            <Switch>
              <Route path="/" exact component={Landing} />
              <Route path="/passsguard" exact component={PasssGuard} />
              <Route path="/carpark" exact component={Carpark} />
              <Route path="/spendguard" exact component={SpendGuard} />
              <Route path="/gameguard" exact component={GameGuard} />
              <Route path="/transportguard" exact component={TransportGuard} />
              <Route path="/footagedoctor" exact component={FootageDoctor} />
              <Route path="/footagedoctor/privacy" exact component={FootageDoctorPrivacy} />
            </Switch>
          </ScrollToTop>
        </div>
      </Router>
    </div>
  );
}

export default App;
